import { ConfirmDelete } from "components/ConfirmDialog/ConfirmDelete";
import { getBoardRoleName } from "enums/BoardRoleEnum";
import { BoardRoleEnum } from "enums/BoardRoleEnum";
import { useApi, useBoardSettings, useEditBoardGroupPanel, useToasts, useTranslations } from "providers";
import React, { useCallback } from "react";

export const ConfirmDeleteGroupMember: React.FC = () => {
  const i18n = useTranslations();
  const { boardId } = useBoardSettings();
  const { boardMembersApi } = useApi();
  const toasts = useToasts();
  const { role, confirmDeleteMember, setConfirmDeleteMember, setDeletingUserId, reloadGroupMembers } =
    useEditBoardGroupPanel();

  const isOpen = confirmDeleteMember !== undefined;

  const handleRemove = useCallback(
    async (userId: number) => {
      if (!boardId || !role) return;

      const userIdString = userId.toString();
      const roleName = BoardRoleEnum[role].toLowerCase();
      const roleLabel = getBoardRoleName(role, i18n);
      setDeletingUserId(userId);

      try {
        await boardMembersApi.removeGroupMember(boardId, roleName, userIdString);
      } catch (error) {
        toasts.addFailure(roleLabel, userIdString, error);
      } finally {
        setDeletingUserId(null);
        setConfirmDeleteMember(undefined);
        reloadGroupMembers();
      }
    },
    [boardId, role, i18n, boardMembersApi, toasts, setDeletingUserId, setConfirmDeleteMember, reloadGroupMembers]
  );

  const setIsOpen = useCallback(
    (open: boolean) => {
      if (!open) {
        setConfirmDeleteMember(undefined);
      }
    },
    [setConfirmDeleteMember]
  );

  return (
    <ConfirmDelete
      entityName={i18n.Member}
      entityTitle={confirmDeleteMember?.title}
      onAccept={() => confirmDeleteMember && handleRemove(confirmDeleteMember.id)}
      onCancel={() => setConfirmDeleteMember(undefined)}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
};
